import { render } from "./PortfolioHome.vue?vue&type=template&id=cf038bd0"
import script from "./PortfolioHome.vue?vue&type=script&lang=js"
export * from "./PortfolioHome.vue?vue&type=script&lang=js"

import "./PortfolioHome.vue?vue&type=style&index=0&id=cf038bd0&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__